"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getBlockByPath_1 = __importDefault(require("./getBlockByPath"));
const getChildrenByPath_1 = __importDefault(require("./getChildrenByPath"));
const getFragmentByPath_1 = __importDefault(require("./getFragmentByPath"));
const createTextFragments_1 = __importDefault(require("./createTextFragments"));
const reducer = (state, char, i) => {
    const blocks = getChildrenByPath_1.default(state.viewState, state.blockPath);
    const block = getBlockByPath_1.default(state.viewState, state.blockPath);
    const fragment = getFragmentByPath_1.default(block, state.fragPath);
    const type = 'type' in char ? char.type : null;
    if (type == null) {
        state.currentText.push(char);
        return state;
    }
    if (state.currentText.length > 0) {
        if (fragment != null && 'fragments' in fragment) {
            fragment.fragments = fragment.fragments.concat(createTextFragments_1.default(state.currentText));
        }
        else {
            block.fragments = block.fragments.concat(createTextFragments_1.default(state.currentText));
        }
        block.value = block.value.concat(state.currentText);
        state.currentText = [];
    }
    if (type === 'fragment-start') {
        let frag = char;
        if ('fragments' in fragment) {
            state.fragPath.push(fragment.fragments.length);
            fragment.fragments.push({
                fragments: [],
                data: frag.data
            });
        }
        else {
            state.fragPath.push(block.fragments.length);
            block.fragments.push({
                fragments: [],
                data: frag.data
            });
        }
    }
    else if (type === 'fragment-end') {
        state.fragPath.pop();
    }
    else if (type === 'block-start') {
        let _char = char;
        const _block = {
            fragments: [],
            value: [],
            blocks: [],
            blockLevel: state.blockPath.length,
            blockKey: _char.blockKey,
            styles: _char.styles != null ? _char.styles : [],
        };
        blocks.push(_block);
        state.blockPath.push(blocks.length - 1);
    }
    else if (type == 'block-end') {
        state.blockPath.pop();
    }
    return state;
};
function reduceViewState(flat) {
    const initialState = {
        viewState: {
            blocks: [],
        },
        i: 0,
        blockPath: [],
        fragPath: [],
        currentText: []
    };
    return flat.value.reduce(reducer, initialState).viewState;
}
exports.default = reduceViewState;
//# sourceMappingURL=reduceViewState.js.map